
























































































import {Component, Vue} from 'vue-property-decorator';
import {Action, Getter} from 'vuex-class';
import ImageUploader from '../../files/_components/imageUploader.vue';
import DatePicker from '../../../components/date-picker.vue';

@Component({
  components: {
    DatePicker,
    ImageUploader,
  },
})
export default class DlgAdNew extends Vue {
  public $refs!: {
    image: any,
    form: any,
  };

  private dialog: boolean = false;
  private valid: boolean = true;
  private ad: any = {};
  private loading: boolean = false;

  @Action('ads/create') private adCreate!: any;
  @Action('ads/read') private adGetAll!: any;
  @Getter('rules/all') private rules!: any;

  private save() {
    if (this.$refs.form.validate()) {
      this.loading = true;

      this.$refs.image.doUpload()
        .then((filename: string) => {
          // tslint:disable-next-line
          console.log(filename);
          this.ad.imageUrl = filename;
          return this.adCreate(this.ad);
        })
        .then((success: boolean) => {
          this.loading = false;
          if (success) {
            this.ad = {};
            this.adGetAll();
            this.dialog = false;
          }
        });
    }
  }
}
